import { cn } from '../../lib/format.js';

const tones = {
  neutral: 'bg-mist/60 text-ink',
  accent: 'bg-accent-soft text-accent',
  success: 'bg-success/10 text-success',
  danger: 'bg-danger/10 text-danger',
  outline: 'border border-mist text-muted',
  solid: 'bg-ink text-white',
};

/**
 * Small status labels. Monospace and letter-spaced, matching the spec strip, so
 * every piece of data in the store reads in the same voice.
 */
export const Badge = ({ tone = 'neutral', className, children, ...props }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 px-2 py-1 font-mono text-2xs tracking-[0.1em] uppercase',
      tones[tone],
      className,
    )}
    {...props}
  >
    {children}
  </span>
);

export default Badge;
